import styled from 'styled-components';
import { Box } from '@rsos/components/capstone/base';

export const EmbeddedErrorContainer = styled(Box).attrs({
  backgroundColor: 'background',
  padding: '10px',
  overflow: 'hidden',
  maxWidth: '675px',
  height: 175,
})`
  border: ${({ theme }) => `1px solid ${theme.colors.heavyLineOutline}`};
  border-radius: 5px;
`;
